import { z } from 'zod';
import { UserStatusSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
/** PUT /api/me/status */
export const SetUserStatusInputSchema = z.object({ status: UserStatusSchema });
/** Who made a status change: the user by hand, or the inactivity expiry job (see
 * STATUS_INACTIVITY_TIMEOUT_MS). Log entries written before this field existed are manual. */
export const STATUS_CHANGE_SOURCES = ['manual', 'auto'];
export const StatusChangeSourceSchema = z.enum(STATUS_CHANGE_SOURCES);
/**
 * orgs/{orgId}/statusLog/{id} — one entry per status change, fanned out to every org the user
 * belongs to at the time, so an org admin's query never has to reach outside their own org.
 * `prevStatus` is what lets a time range be reconstructed from only the entries inside it: the
 * status at the start of the range is the first in-range entry's `prevStatus` (or, with no
 * entries in range, the user's current status). Written by the API only.
 *
 * An `auto` entry is dated to the user's last activity, not to when the expiry job noticed, so
 * the time they were away isn't counted as online.
 */
export const UserStatusLogEntrySchema = z.object({
    uid: IdSchema,
    status: UserStatusSchema,
    prevStatus: UserStatusSchema,
    at: IsoDateTimeSchema,
    source: StatusChangeSourceSchema.optional(),
});
/**
 * presence/{uid} — when the user last did something in the app. Written by the API only (POST
 * /api/me/presence, and PUT /api/me/status, since setting a status is activity too) and read
 * only by the API's status expiry job. It's kept off users/{uid} on purpose: every status dot
 * is a live listener on that doc, so a ping there would be a read for every client watching.
 */
export const PresenceSchema = z.object({ lastActiveAt: IsoDateTimeSchema });
/** The web app pings presence at most this often while someone is active. */
export const PRESENCE_PING_INTERVAL_MS = 5 * 60_000;
/** Online or busy with no activity for this long, and the expiry job sets you offline. */
export const STATUS_INACTIVITY_TIMEOUT_MS = 30 * 60_000;
//# sourceMappingURL=userStatus.js.map